export default __webpack_public_path__ + "static/media/accelerating-pop-label.07e29c89.svg";